import { alpha, Box, IconButton, InputAdornment, TextField, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useState } from "react";

export default function MainInput(props) {
    const { label, name, type, placeholder, required, sx, error, inputPattern, helperText, value, onChange, disabled, isSecure = false, fullWidth = true, preIcon } = props;
    const { mode } = useColorScheme();

    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    const currentMode = mode ? mode : "light";

    return (
        <Box>
            {label && <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                {label}
            </Typography>}
            <TextField
                size="small"
                name={name}
                type={isSecure && !showPassword ? "password" : type}
                placeholder={placeholder}
                required={required}
                fullWidth={fullWidth}
                multiline={type === "textarea"}
                rows={type === "textarea" ? 4 : 1}
                error={error}
                slotProps={{
                    pattern: inputPattern,
                    input: {
                        startAdornment: preIcon && <InputAdornment position="start">
                            {preIcon}
                        </InputAdornment>,
                        endAdornment: isSecure && <InputAdornment position="end">
                            <IconButton
                                aria-label={
                                    showPassword ? 'hide the password' : 'display the password'
                                }
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                onMouseUp={handleMouseUpPassword}
                                edge="end"
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    }
                }}
                helperText={helperText}
                value={value}
                onChange={onChange}
                disabled={disabled}
                sx={{
                    ...sx,
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: alpha(Constants.Colors[currentMode].background, 1),
                        fontSize: "14px",
                    },
                    // Class for the border around the input field
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: Constants.Colors[currentMode].border,
                    },
                    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                        borderColor: Constants.Colors[currentMode].accent,
                    },
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: Constants.Colors[currentMode].accent,
                    },
                }}
            />
        </Box>
    );
}